const SERVER_ENV = process.env.VUE_APP_SEVERENV

const host_beta = {
    mainHost: '//portal.haiziwang.com',
    cmsHost: '//cms.haiziwang.com',
    ruleHost: '//soperationapi.haiziwang.com'
}

const host_idc = {
    mainHost: '//portal.haiziwang.com',
    cmsHost: '//cms.haiziwang.com',
    ruleHost: '//soperationapi.haiziwang.com'
}

export const host = SERVER_ENV === 'BETA' ? host_beta : host_idc

//  host
const _subRuleHost = '/soperation-api'
const mainContentPath = '/portal-api'

let portal_api = {
    queryAccountInfo:'/account/queryAccountInfo.do',//查询用户信息(不校验登录态)
    queryAccountInfoNeedLogin:'/account/queryAccountInfoNeedLogin.do',//查询用户信息(校验登录态)
    bindAccount:'/account/bindAccount.do',
    logout:'/user/logout.do',
    getPortalMenu:'/user/getPortalMenu.do'
}

Object.entries(portal_api).forEach(([key,value])=>{
    value = `${host.mainHost}${mainContentPath}${value}`
    Reflect.set(portal_api, key, value);
})
export const portalApi = portal_api

let _ruleApi = {
    getCategories: '/bmsCategory/getCategories.do',
    getListByCategoryId: '/bmsRule/getListByCategoryId.do',
    getDetailById: '/bmsRule/getDetailById.do',
    search: '/bmsRule/search.do',
}

Object.entries(_ruleApi).forEach(([key, value]) => {
    value = `${host.ruleHost}${_subRuleHost}${value}`
    Reflect.set(_ruleApi, key, value)
})

export const ruleApi = _ruleApi
